import { render } from "./addressList.vue?vue&type=template&id=623d2ed2&scoped=true&ts=true"
import script from "./addressList.vue?vue&type=script&lang=ts"
export * from "./addressList.vue?vue&type=script&lang=ts"

import "./addressList.vue?vue&type=style&index=0&id=623d2ed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623d2ed2"]])

export default __exports__